import { tagAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'
import { colors } from '../cssVariables/colors'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tagAnatomy.keys)

const roundedStyle = definePartsStyle({
  // define the part you're going to style
  container: {
    bg: colors.colorA3,
    color: colors.colorB7,
    borderRadius: '4px',
    fontWeight: 700,
    lineHeight: '100%',
    padding: '2px 4px',
    textTransform: 'uppercase',
    zIndex: 1,
    position: 'relative',
  },
})

const md = defineStyle({
  fontSize: '12px',
  height: '19px',
  minH: '19px',
})

const sm = defineStyle({
  fontSize: '10px',
  height: '14px',
  minH: '14px',
})

const sizes = {
  sm: definePartsStyle({ container: sm }),
  md: definePartsStyle({ container: md }),
}

export const Tag = defineMultiStyleConfig({
  variants: { rounded: roundedStyle },
  sizes,
})
